import React, { createContext, useContext, useState, useEffect } from 'react';
import { Moon, Sun } from 'lucide-react';

const ThemeContext = createContext({
  isDarkMode: false,
  toggleTheme: () => {}
});

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    document.body.style.backgroundColor = isDarkMode ? '#22252B' : '#FCFCFC';
    document.body.style.color = isDarkMode ? '#BBC2D4' : '#2C3E50';
    document.documentElement.style.backgroundColor = isDarkMode ? '#22252B' : '#FCFCFC';
    document.documentElement.setAttribute('data-theme', isDarkMode ? 'dark' : 'light');
  }, [isDarkMode]);

  const toggleTheme = () => setIsDarkMode(prev => !prev);

  return (
    <ThemeContext.Provider value={{ isDarkMode, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const ThemeSwitcher = () => {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      style={{
        position: 'fixed',
        bottom: '15px',
        right: '15px',
        padding: '0px',
        width: '45px',
        height: '45px',
        borderRadius: '50%',
        cursor: 'pointer',
        backgroundColor: isDarkMode ? '#333' : '#fff',
        border: `1px solid ${isDarkMode ? '#444' : '#e0e0e0'}`,
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        transition: 'background-color 0.2s ease-in-out',
        zIndex: 1000
      }}
      aria-label="Toggle theme"
    >
      {isDarkMode ? (
        <Sun className="w-6 h-6" color="#BBC2D4" />
      ) : (
        <Moon className="w-6 h-6" color="#2C3E50" />
      )}
    </button>
  );
};